import React, { useEffect, useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { editCollectionRegister, handleChangeController } from '../../../redux/actions/form'
import { removeError } from '../../../redux/actions/validator'
import { InputValidator } from './InputValidator'
import ReactQuill from 'react-quill'
import '@styles/react/libs/editor/editor.scss'
import 'react-quill/dist/quill.snow.css'
import { useCollection } from '../../../utility/hooks/useCollection'



export const Textarea = ({ name, label, value = '', className, containerClassname = 'mt-1', placeholder = label, styles, errMsg = '', readOnly = false, disabled, rows = 3, editor = false, onCustomChange = null, position, collection, ...props }) => {
    const modules = {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
            [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
            ['link', 'clean']
        ]
    }

    const formats = [
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image', 'align'
    ]

    const dispatch = useDispatch()

    const { form, validator } = useSelector(state => state)
    const [editorText, setEditorText] = useState(form[name] ? form[name] : '')

    const nodeForm = useCollection().getCollectionNode(form, collection)
    const valueForm = nodeForm[name]
    useEffect(() => {
        setEditorText(form[name] ? form[name] : '')
    }, [form[name]])

    const handleInputChange = ({ target }) => {
        const v = props.type === 'number' ? parseInt(target.value) : target.value
        if (!collection) dispatch(handleChangeController(target.name, v))
        else dispatch(editCollectionRegister(position !== null ? [...collection, position] : [...collection],
            { name: target.name, value: v }))
        dispatch(removeError(validator.errors))
        dispatch(handleChangeController('edited', true))
    }

    const handleInputEditorChange = (data) => {
        setEditorText(data)
        if (validator.errors && validator.errors[name]) delete validator.errors[name]
        dispatch(removeError(validator.errors))
        dispatch(handleChangeController(name, data))
    }


    return (
        <div className={containerClassname} >
            <label className="control-label d-flex justify-content-between">{label} {<InputValidator errMsg={errMsg} errors={validator.errors} target={name} />}</label>
            {
                editor ? (
                    <>
                        <ReactQuill
                            theme='snow'
                            readOnly={readOnly}
                            modules={modules}
                            formats={formats}
                            value={value || editorText}
                            onChange={onCustomChange ? onCustomChange : handleInputEditorChange}
                            style={{ height: '20rem', paddingBottom: '5rem', fontSize: '13px' }}
                        />
                    </>
                ) : (<textarea
                    style={{ ...styles }}
                    disabled={disabled}
                    readOnly={readOnly && 'readOnly'}
                    className={`form-control ${className} ${validator.errors && validator.errors[name] ? 'borderless border-danger rounded' : ''}`}
                    name={name}
                    placeholder={placeholder}
                    value={value || valueForm}
                    onChange={onCustomChange ? onCustomChange : handleInputChange}
                    autoComplete="off"
                    rows={rows}
                />)
            }
        </div>
    )
}